const ACpricingConfig = {
  Split: {
    10: {
      "5years": {
        subscription: 1168,
        depositamount: 6000,
        installetionCharge: 1770,
        addOn: 25,
      },
      "3+2year": {
        subscription: 1328,
        depositamount: 6000,
        priceAfter3Years: 856,
        installetionCharge: 1770,
        addOn: 25,
      },
    },
    15: {
      "5years": {
        subscription: 1168,
        depositamount: 7000,
        installetionCharge: 1770,
        addOn: 25,
      },
      "3+2year": {
        subscription: 1328,
        depositamount: 7000,
        priceAfter3Years: 856,
        installetionCharge: 1770,
        addOn: 25,
      },
    },
    20: {
      "5years": {
        subscription: 1416,
        depositamount: 8000,
        installetionCharge: 1770,
        addOn: 25,  
      },
      "3+2year": {
        subscription: 1623,
        depositamount: 8000,
        priceAfter3Years: 1033,
        installetionCharge: 1770,
        addOn: 25
      },
    },
  },
  Cassette: {
    20: {
      "3+2year": {
        subscription: 2213,
        depositamount: 15000,
        priceAfter3Years: 1269,
        installetionCharge: 3894,
        addOn: 50
      },
      "5years": {
        subscription: 1888,
        depositamount: 15000,
        installetionCharge: 3894,
        addOn: 50
      },
    },
    30: {
      "3+2year": {
        subscription: 2921,
        depositamount: 18000,
        priceAfter3Years: 1387, 
        installetionCharge: 3894,
        addOn: 50
      },
      "5years": {
        subscription: 2360,
        depositamount: 18000,
        installetionCharge: 3894,
      },
    },
  },
};

export default ACpricingConfig;
